<template>
	
	<AlertDialog ref="alert"></AlertDialog>
	<InputDialog ref="input"></InputDialog>
	<InputSelectDialog ref="input_select"></InputSelectDialog>
	<ConfirmDialog ref="confirm"></ConfirmDialog>

	<div id="app_inner" :class="{'nav_open': nav, 'scan': state.scan}">
		<header class="bg-black text-white px-2 w-full flex items-center gap-2" @click="nav = !nav">
			<Backburger v-if="nav" class="text-xl"></Backburger>
			<Menu v-else class="text-xl"></Menu>
			<span>airTool {{state.version}}</span>
			<span id="route_title"></span>
		</header>
		<nav class="p-2 z-10 bg-primary text-white">
			<router-link @click="nav = false" to="/">Startseite</router-link>
			<router-link @click="nav = false" to="/airlpt">airLPT</router-link>
			<router-link @click="nav = false" to="/ldk">LDK-Rechner</router-link>
			<router-link @click="nav = false" to="/uc">Einheitenrechner</router-link>
			<router-link @click="nav = false" to="/dim">Dimensionierung</router-link>
			<router-link @click="nav = false" to="/canal">Kanal-Rechner</router-link>
			<router-link @click="nav = false" to="/tube">Rohr-Rechner</router-link>
			<router-link @click="nav = false" to="/montage">Montagematerial</router-link>
			<router-link @click="nav = false" to="/qr">QR-Scanner</router-link>
			<hr class="w-full my-2" />
			<a @click.prevent="nav = false; contact();" href="#">Kontakt</a>
			<a @click="nav = false" href="https://airleben.de" target="_blank">Über uns</a>
			<a @click="nav = false" href="https://www.airleben.de/service/seminare"  target="_blank">Schulungen</a>
			<router-link @click="nav = false" to="/imp">Impressum</router-link>
			<a @click="nav = false" href="https://airleben.de/datenschutz" target="_blank">Datenschutz</a>
		</nav>
		<div id="nav_bg" @click="nav = false"></div>
		<main>
			 
			<div v-if="state.loading" class="absolute left-0 top-0 w-full h-full flex justify-center items-center bg-white bg-opacity-75 z-10">
				... Bitte warten ...
			</div>
			
			<router-view v-model:state="state" v-slot="{ Component }">
				<transition name="fade" mode="out-in">
                    <component :is="Component" />
                </transition>
			</router-view>
			
		</main>
	</div>
			 
</template>

<script>

	import { Menu, Backburger } from 'mdue';
	import AlertDialog from "@/components/AlertDialog";
	import InputDialog from "@/components/InputDialog";
	import InputSelectDialog from "@/components/InputSelectDialog";
	import ConfirmDialog from "@/components/ConfirmDialog";

	export default {
		components: { 
			Menu, Backburger, 
			AlertDialog, InputDialog, InputSelectDialog, ConfirmDialog
		},
		data() {
			return {
				nav: false,
				state: {
					version: '3.2',
					scan: false,
					loading: false,
					dim: {
						mode: 'input',
						input: {
							vstrom_m3h: null,
							vstrom_ls: null,
							vstrom_lh: null,
							speed_ms: null,
							mode: null,
							height_mm: null,
							width_mm: null,
							type: 'kanal',
							diameter: null
						},
						output: {
							area_mm2: null,
							area_m2: null,
							diameter_mm: null,
							height_mm: null,
							width_mm: null
						},
						hd: {
							type: 'rund',
							diameter: null,
							a: null,
							b: null,
							h: null,
							area_m2: null,
							hyd_mm: null,
							hyd_propose_mm: null
						},
						rundeckig: {
							re: {
								input: {
									normalwidth_mm: null,
									height_mm: null,
									width_mm: null,
								},
								output: {
									area_m2: null,
									height_mm: null,
									width_mm: null
								}
							},
							er: {
								input: {
									height_mm: null,
									width_mm: null
								},
								output: {
									area_m2: null,
									normalwidth_mm: null,
									diameter_mm: null
								}
							}
						}
					},
					ldk: {
						mode: 'input',
						source: undefined,
						input: {
							type: 'kanal',
							ldk_class: 'a',
							leckage_lsm2: undefined,
							testpressure_pa: 400,
							usagepressure_pa: undefined,
							area_m2: undefined,
							pressure: 101325,
							temparature: 20
						},
						output: {
							max_leckage_m3_s: undefined, // ausgabe_maxluftleckrate_m3_s
							luftleckrate_norm_m3_s: undefined,
							luftleckrate_norm_l_s: undefined,
							luftleckrate_norm_m3_h: undefined,
							luftleckrate_m3_s: undefined,
							luftleckrate_l_s: undefined,
							luftleckrate_m3_h: undefined,
							luftleckrate: undefined,
							luftleckratecalc: undefined
						}
					},
					unit: {
						input: {
							unit: 'pressure',
							value1: undefined, unit1: undefined,
							value2: undefined, unit2: undefined,
						}
					},
					canal: {
						mode: 'input',
						input: {
							height_mm: undefined,
							width_mm: undefined,
							length_mm: undefined,
							amount: 1,
							material: 'Stahl verz.',
							materialstrength: 0.75
						},
						output: {
							ratio: undefined,
							scope_mm: undefined,
							scope_m: undefined,
							freeprofile_m2: undefined,
							freeprofile_mm2: undefined,
							weight: undefined
						}
					},
					tube: {
						mode: 'input',
						input: {
							diameter_mm: undefined,
							length_mm: undefined,
							amount: 1,
							material: 'Stahl verz.',
							materialstrength: 1
						},
						output: {
							scope_mm: undefined,
							scope_m: undefined,
							weight: undefined,
							surface_m2: undefined,
							profile_m2: undefined,
							profile_mm2: undefined
						}
					},
					montage: {
						mode: 'input',
						input: {
							type: 'canal',
							canal_height_mm: undefined,
							canal_width_mm: undefined,
							canal_length_m: undefined,
							tube_diameter_mm: undefined,
							tube_length_m: undefined,
							amount: 1,
							flansch_canal: 'EP20',
							flansch_tube: 'Steckverbindung'
						},
						output: { 
							strBand: undefined,
							strSchrauben: undefined,
							strSpannringe: undefined,
							strNieten: undefined,
							strSDE: undefined,
							strKlemmen: undefined,
						}
					}
				}
			}
		},
		provide() {
			return {
				trans: this.trans,
				round: this.round,
				alert: this.alert, input: this.input, confirm: this.confirm, input_select: this.input_select,
				sendMail: this.sendMail,
				ff2: this.ff2,
				ff4: this.ff4,
				ff5: this.ff5,
				ff: this.ff,
				tf: this.tf
			}
		},
		methods: {
			trans(value) { return value; },
			round(value, decimals) {
			
				return Math.round((value + Number.EPSILON) * Math.pow(10, decimals)) / Math.pow(10, decimals);
				
			},
			alert(msg, title, cb_ok) {

				if (title === undefined) title = this.trans('Hinweis');

				this.$refs.alert.show(title, msg, cb_ok);

			},
			confirm(title, msg, cb_ok, cb_cancel, options) {

				if (title === undefined) title = this.trans('Frage');
				if (msg === undefined) msg = this.trans('Sind Sie sich sicher?');

				this.$refs.confirm.show(title, msg, cb_ok, cb_cancel, options);

			},
			input(title, msg, placeholder, cb_ok, cb_cancel) {

				if (title === undefined) title = this.trans('Frage');
				if (msg === undefined) msg = '';
				if (placeholder === undefined) placeholder = 'Begründung';

				this.$refs.input.show(title, msg, placeholder, cb_ok, cb_cancel);

			},
			input_select(title, options, value, cb_ok) {
				
				this.$refs.input_select.show(title, options, value, cb_ok);
				
			},
			sendMail(arReplace, template) {
				
				let strMail = '';
				let subject = '';
				let to = '';
				
				if (template === 'ldk') {
					
					subject = 'Ihre Dimensionierung';
					strMail = `Hallo,

Hiermit erhalten sie die Berechnung der Luftdichtheitsklasse.

Die Berechnung beruht auf folgenden Eingaben:

Typ: ###TYP###
Dichtheitklasse: ###KLASSE###
Grenzwert der Luftleckrate: ###GRENZWERT### l/s m²
Prüfdruck: ###DRUCK### Pa
Oberfläche: ###OBERFLAECHE### m²
###SOURCE###
Die Berechnung ergab folgende Werte:

Max. Luftleckrate in m³/s * m²: ###MAXLECKRATE###
Luftleckrate in m³/s: ###LECKRATE_M###
Luftleckrate in m³/h: ###LECKRATE_H###
Luftleckrate in l/s: ###LECKRATE_L###

Bedingungen:
Athmosphärischer Druck in Pa: ###ATM_DRUCK###
Temperatur in °C: ###ATM_TEMPERATUR###

Luftleckrate unter Normbedingungen (###NORM_DRUCK### und ###NORM_TEMPERATUR###):
Luftleckrate in m³/s: ###LECKRATE_NORM_M###
Luftleckrate in m³/h: ###LECKRATE_NORM_H###
Luftleckrate in l/s: ###LECKRATE_NORM_L###

Näherungsweise Bestimmung bei Betriebsdruck:
Betriebsdruck in Pa: ###BDRUCK###
Betriebsleckluftrate in l/s: ###BLECK###

Der Hersteller übernimmt keine Gewähr für die Berechnung.
Es wird darauf hingewiesen, dass diese Software möglicherweise technische Fehler enthält.
Die Nutzung dieser Software erfolgt auf eigene Gefahr des Anwenders.

Viele Grüße

airleben Sie Lüftungskompetenz auf höchstem Niveau.`; 
					
				} else if (template === 'contact') {
					
					subject = 'Ihre Anfrage an die airleben  Gruppe';
					strMail = '';
					to = 'tool@airleben.de';
					
				} else if (template === 'dimensioning_view') {
					
					subject = 'Ihre Dimensionierung';
					strMail = `Hallo,

Hiermit erhalten sie ihre Eingaben der Dimensionierung.

Sie haben folgende Eingaben gemacht:

Volumenstrom in l/h: ###VOLUMENSTROM_L###
Volumenstrom in m³/h: ###VOLUMENSTROM_M###
Volumenstrom in l/h: ###VOLUMENSTROM_H###
Geschwindigkeit in m/s: ###GESCHWINDIGKEIT###

Die Berechnung ergab folgende Werte:

Maße für runden Durchmesser (Rohr):
Empfohlener Durchmesser in mm: ###DURCHMESSER_MM###

Maße für eckigen Durchmesser (Kanal):
Höhe in mm: ###HOEHE_MM###
Breite in mm: ###BREITE_MM###

Der Hersteller übernimmt keine Gewähr für die Berechnung.
Es wird darauf hingewiesen, dass diese Software möglicherweise technische Fehler enthält.
Die Nutzung dieser Software erfolgt auf eigene Gefahr des Anwenders.

Viele Grüße

airleben Sie Lüftungskompetenz auf höchstem Niveau.`;
					
				} else if (template === 'dimensioning_view') {
					
					subject = 'Ihre Dimensionierung';
					strMail = `Hallo,

Hiermit erhalten sie ihre Eingaben der Dimensionierung des hydraulischen Durchmessers.

Sie haben folgende Eingaben gemacht:

Flächentyp: ###TYP###
Mass 1 in mm: ###MASS1###
Mass 2 in mm: ###MASS1###

Die Berechnung ergab folgende Werte:

Fläche: ###QUERSCHNITT### m²
Hydraulischer Durchmesser (berechnet): ###DURCHMESSER_HD###
Hydraulischer Durchmesser (empfohlen): ###DURCHMESSER_EMPF### mm


Der Hersteller übernimmt keine Gewähr für die Berechnung.
Es wird darauf hingewiesen, dass diese Software möglicherweise technische Fehler enthält.
Die Nutzung dieser Software erfolgt auf eigene Gefahr des Anwenders.

Viele Grüße

airleben Sie Lüftungskompetenz auf höchstem Niveau.`;

				} else if (template === 'qr_history') {
					
					subject = 'Ihr gescannter QR Code Verlauf';
					strMail = `Hallo,

Hiermit erhalten sie ihre gescannten QR Codes

###QR###
Viele Grüße

airleben Sie Lüftungskompetenz auf höchstem Niveau.
`;
					
				} else if (template === 'qr') {
					
					subject = 'Ihr gescannter QR Code';
					strMail = `Hallo,

Hiermit erhalten sie ihren gescannten QR Code

###QR###

Viele Grüße

airleben Sie Lüftungskompetenz auf höchstem Niveau.
`;
					
				} else if (template === 'montage_canal') {
					
					subject = 'Ihre Montagematerialberechnung'; 
					strMail = `Hallo,

Hiermit erhalten sie ihre Eingaben des Montagerechners.

Sie haben folgende Eingaben gemacht:

Typ:Kanal (Eckiger Querschnitt)
Höhe in mm: ###HOEHE###
Breite in mm: ###BREITE###
Länge m: ###LAENGE###
Menge: ###MENGE###
Flanschart: ###FLANSCHART###

Die Berechnung ergab folgende Werte:

Superdichtecke: ###SUPERDICHTECKE###
Luftkanaldichtband: ###LUFTKANALDICHTBAND###
Kanalklemmen: ###KANALKLEMMEN###
Schrauben: ###SCHRAUBEN###

Der Hersteller übernimmt keine Gewähr für die Berechnung.
Es wird darauf hingewiesen, dass diese Software möglicherweise technische Fehler enthält.
Die Nutzung dieser Software erfolgt auf eigene Gefahr des Anwenders.

Viele Grüße

airleben Sie Lüftungskompetenz auf höchstem Niveau.`;
					
				} else if (template === 'montage_tube') {
					
					subject = 'Ihre Montagematerialberechnung'; 
					strMail = `Hallo,

Hiermit erhalten sie ihre Eingaben des Montagerechners.

Sie haben folgende Eingaben gemacht:

Typ:Rohr (Runder Querschnitt)
Durchmesser in mm: ###DURCHMESSER###
Rohrlänge in m: ###LAENGE###
Menge: ###MENGE###
Flanschart: ###FLANSCHART###

Die Berechnung ergab folgende Werte:

Vorlegeband: ###VORLEGEBAND###
Druckdichte Nieten / selbstbohrende Schrauben: ###NIETEN###
Schrauben M8x25: ###SCHRAUBEN###
Spannringe SR: ###SR###

Der Hersteller übernimmt keine Gewähr für die Berechnung.
Es wird darauf hingewiesen, dass diese Software möglicherweise technische Fehler enthält.
Die Nutzung dieser Software erfolgt auf eigene Gefahr des Anwenders.

Viele Grüße

airleben Sie Lüftungskompetenz auf höchstem Niveau.`;
					
				} else if (template === 'canal') {
					
					subject = 'Ihre Kanalrechnung'; 
					strMail = `Hallo,

Hiermit erhalten sie die Berechnung ihres Kanals.

Die Berechnung beruht auf folgenden Eingaben:

Breite: ###BREITE_MM###mm (###BREITE_M###m)
Höhe: ###HOEHE_MM###mm (###HOEHE_M###m)
Länge: ###LAENGE_MM###mm (###LAENGE_M###m)
Menge: ###MENGE###Stück

Die Berechnung ergab folgende Werte:

Kanalumfang: ###UMFANG_MM###mm (###UMFANG_M###m)
Kanalquerschnitt: ###QUERSCHNITT_MM###mm² (###QUERSCHNITT_M###m²)
Kanaloberfläche: ###OBERFLAECHE###m²
Gewicht: ###GEWICHT###kg
Material: ###MATERIAL###
Materialstärke: ###MATERIALSTAERKE###mm

Der Hersteller übernimmt keine Gewähr für die Berechnung.
Es wird darauf hingewiesen, dass diese Software möglicherweise technische Fehler enthält.
Die Nutzung dieser Software erfolgt auf eigene Gefahr des Anwenders.

Viele Grüße

airleben Sie Lüftungskompetenz auf höchstem Niveau.`;
					
				} else if (template === 'tube') {
					
					subject = 'Ihre Rohrberechnung'; 
					strMail = `Hallo,

Hiermit erhalten sie die Berechnung ihres Rohres.

Die Berechnung beruht auf folgenden Eingaben:

Durchmesser: ###DURCHMESSER_MM###mm (###DURCHMESSER_M###m)
Länge: ###LAENGE_MM###mm (###LAENGE_M###m)

Die Berechnung ergab folgende Werte:

Rohrumfang: ###UMFANG_MM###mm (###UMFANG_M###m)
Rohrquerschnitt: ###QUERSCHNITT_MM###mm² (###QUERSCHNITT_M###m²)
Rohroberfläche: ###OBERFLAECHE###m²
Gewicht: ###GEWICHT###
Material: ###MATERIAL###
Materialstärke: ###MATERIALSTAERKE###mm

Der Hersteller übernimmt keine Gewähr für die Berechnung.
Es wird darauf hingewiesen, dass diese Software möglicherweise technische Fehler enthält.
Die Nutzung dieser Software erfolgt auf eigene Gefahr des Anwenders.

Viele Grüße

airleben Sie Lüftungskompetenz auf höchstem Niveau.`;
					
				} else if (template === 'dimensioning_view_hd') {
					
					subject = 'Ihre Dimensionierung'; 
					strMail = `Hallo,

Hiermit erhalten sie ihre Eingaben der Dimensionierung des hydraulischen Durchmessers.

Sie haben folgende Eingaben gemacht:

Flächentyp: ###TYP###
Mass 1 in mm: ###MASS1###
Mass 2 in mm: ###MASS1###

Die Berechnung ergab folgende Werte:

Fläche: ###QUERSCHNITT### m²
Hydraulischer Durchmesser (berechnet): ###DURCHMESSER_HD###
Hydraulischer Durchmesser (empfohlen): ###DURCHMESSER_EMPF### mm


Der Hersteller übernimmt keine Gewähr für die Berechnung.
Es wird darauf hingewiesen, dass diese Software möglicherweise technische Fehler enthält.
Die Nutzung dieser Software erfolgt auf eigene Gefahr des Anwenders.

Viele Grüße

airleben Sie Lüftungskompetenz auf höchstem Niveau.`;
					
				}
				
				for (let i in arReplace) {
					 
					strMail = strMail.replaceAll(i, arReplace[i]);
					
				}

				console.log(template, subject, strMail);

				window.sendMailCordova(subject, strMail, to);

			},
			tf(value) {
			
				return parseFloat(value.toString().replace(',', '.'));
				
			},
			ff(value) {
			
				return value.toString().replace('.', ',');
				
			},
			ff2(value) { 
			
				let v = parseFloat(value);
				let r = undefined;
				
				if (typeof value === 'number' && isNaN(v)) r = '';
				else r = parseFloat(value).toFixed(2);
			
				if (r === 'NaN') r = '';
					
				r = r.toString().replace('.', ',');
				
				return r;
				
			},
			ff4(value) { 
			
				let v = parseFloat(value);
				let r = undefined;
				
				if (typeof value === 'number' && isNaN(v)) r = '';
				else r = parseFloat(value).toFixed(4);
			
				if (r === 'NaN') r = '';
					
				r = r.toString().replace('.', ',');
				
				return r;
				
			},
			ff5(value) { 
			
				let v = parseFloat(value);
				let r = undefined;
				
				if (typeof value === 'number' && isNaN(v)) r = '';
				else r = parseFloat(value).toFixed(4);
			
				if (r === 'NaN') r = '';
					
				r = r.toString().replace('.', ',');
				
				return r;
				
			},
			contact() {
				
				this.sendMail({}, 'contact');
				
			}
		},
		watch: {
            $route (to, from) {
				
				this.state.loading = false;
				this.state.scan = false;
                
            }
		} 
	}

</script>

<style lang="scss">

	$nav_width: 250px;
	
	* { box-sizing:border-box; }

	#app_inner { position:absolute; left:0; top:0; width:100vw; height:100vh; box-sizing:border-box; overflow:auto;
		& > header { height:50px; }
		& > nav { transition:all 0.4s; width:$nav_width; transform:translateX(calc(-1 * $nav_width - 1px)); position:absolute; left:0; top:50px; height:calc(100vh - 50px); overflow:auto; display:flex; flex-direction:column; gap:0.5rem;
			a { font-size:1.25em; margin-left:0.25rem; 
				&.router-link-active { text-decoration:underline; }
			}
		}
		& > #nav_bg { opacity:0; pointer-events:none; transition:all 0.4s; left:0; top:50px; height:calc(100vh - 50px); width:100%; z-index:9; position:absolute; background-color:rgba(0, 0, 0, 0.75); }
		&.nav_open {
			& > nav { transform:translateX(0px); }
			& > #nav_bg { opacity:1; pointer-events:all; }
		}
		& > main {  position:absolute; height:calc(100vh - 50px); width:100%; left:0; top:50px; overflow-y:auto;
			& > .frame { text-align:center;
				& > .inner { margin:0 auto; /*max-width:600px;*/ padding:0.5rem; background-color:#FFFFFF; border-radius:1rem; position:absolute; left:1rem; top:1rem; width:calc(100vw - 2rem); height:calc(100% - 2rem); overflow:auto; border:0.5rem solid white; }
			}
		}
	}
	
	.fade-enter-active,
	.fade-leave-active { transition:opacity 0.5s ease; }

	.fade-enter-from,
	.fade-leave-to { opacity:0; }
	
	body.Android {
		#app_inner {
			& > header { height:50px; padding-top:0; box-sizing:content-box; width:calc(100% - 1rem); }
			& > nav { height:calc(100vh - 50px); top:50px; }
			& > #nav_bg { top:50px; height:calc(100vh - 50px); }
			& > main { height:calc(100vh - 50px); top:50px; }
		}
	}
	
	body.iOS {
		#app_inner {
			& > header { height:50px; padding-top:25px; box-sizing:content-box; width:calc(100% - 1rem); }
			& > nav { height:calc(100vh - 75px); top:75px; }
			& > #nav_bg { top:75px; height:calc(100vh - 75px); }			
			& > main { height:calc(100vh - 75px); top:75px; }
		}
	}
	
	body.browser { background-color:#FFFFFF; 
		#app { text-align:left; width:100%; }
		#app_inner { width:400px; margin:0 auto; left:calc(50% - 200px);
			& > main > .frame > .inner { width:calc(100% - 2rem); }
		}
	}

</style>
